import React, { createContext, useState, useEffect, useContext } from 'react';
import axiosInstance from '../utils/axios';

const ConfigContext = createContext({ linkMap: {}, diabetesKindMap: {} });

export const ConfigProvider = ({ children }) => {
  const [linkMap, setLinkMap] = useState({});
  const [diabetesKindMap, setDiabetesKindMap] = useState({});

  useEffect(() => {
    const fetchLinkMap = async () => {
      try {
        const response = await axiosInstance.get('/file/path-map');

        if (response.data.success) {
          setLinkMap(response.data.data); // expecting value to be map of pathKey to baseUrl
          window.linkMap = response.data.data; // expose globally for helpers
        }
      } catch (e) {
        //console.error('Failed to fetch config:', e);
      }
    };
    
    const fetchDiabetesKinds = async () => {
      try {
        const response = await axiosInstance.get('/mobile/common/diabetes-kinds', {
          params: { language: 'ko' }
        });

        if (response.data.success) {
          // code를 키로 하는 맵 생성 (1 -> '제1형 당뇨병', 2 -> '제2형 당뇨병' 등)
          const kindMap = {};
          response.data.data.diabetes_kind.forEach(item => {
            kindMap[item.code] = item.name;
          });
          setDiabetesKindMap(kindMap);
        }
      } catch (e) {
        //console.error('Failed to fetch diabetes kinds:', e);
      }
    };
    
    fetchLinkMap();
    fetchDiabetesKinds();
  }, []);

  return <ConfigContext.Provider value={{ linkMap, diabetesKindMap }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
